import { ZodError } from 'zod-validation-error';
import { z } from 'zod';

export const parseZodErrors = (error: ZodError) => {
  return error.errors.map((err) => ({
    path: err.path[0] as string,
    message: err.message,
  }));
};

export const stringFieldSchema = (fieldName: string, message: string) =>
  z.object({
    [fieldName]: z.string().refine(
      (val) => {
        return val.length > 0;
      },
      {
        message,
      },
    ),
  });
